<template>
    <div class="session__summary_table">
        <component-table
            :labels="[
                {
                    key: 'fullName',
                    title: 'Name',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'email',
                    title: 'Email',
                    type: 'string',
                    sortable: false
                },
                {
                    key: 'attendance',
                    title: 'Attendance',
                    type: 'string',
                    sortable: false
                },
                {
                    key: 'assessment',
                    title: 'Assessment',
                    type: 'string',
                    sortable: false
                },
                {
                    key: 'notes',
                    title: 'Notes',
                    type: 'string',
                    sortable: false
                }
            ]"
            :checkbox="true"
            :checkbox-name="'summary-item'"
            :list-emit-name="'summary-item'"
            :disabled="disabled"
            :items="items"
            :component-table-item="SessionSummaryTableItem"
        />
    </div>
</template>

<script>
import SessionSummaryTableItem from '@/components/ebs/sessions/summary/SessionSummaryTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  components: {
    ComponentTable
  },
  name: 'session-summary-table',
  data () {
    return {
      SessionSummaryTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionsummarytable";
</style>
